import { render } from "./_type.vue?vue&type=template&id=e2dbf40a"
import script from "./_type.vue?vue&type=script&lang=js"
export * from "./_type.vue?vue&type=script&lang=js"

import "./_type.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__